// extracted by mini-css-extract-plugin
export default {"cls1":"RelatedPapers-cls1__T0","cls2":"RelatedPapers-cls2__MC RelatedPapers-cls1__T0"};